import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IDedupeTask, IEntityMergeCounts, IMergeLog } from '../../shared/interfaces/duplikit-interfaces';

@Injectable({
  providedIn: 'root'
})
export class DuplikitMergeLogService {

  constructor(private http: HttpClient) {}

  getLogForEntity(entity: string, date: Date, masterId: number, duplicateId: number, userId: number): Observable<IDedupeTask[]> {
    let queryString: string;
    queryString = `entity=${entity}`;

    if (date) {
      let formattedDate: string;
      formattedDate = date.getUTCDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
      queryString += `&date=${formattedDate}`;
      const timeZoneOffset = date.getTimezoneOffset();
      queryString += `&offset=${timeZoneOffset}`;
    }
    if (masterId) {
      queryString += `&masterId=${masterId}`;
    }
    if (duplicateId) {
      queryString += `&duplicateId=${duplicateId}`;
    }
    if (userId) {
      queryString += `&userId=${userId}`;
    }

    return this.http.get<IDedupeTask[]>(`${environment.duplikitUrl}/Dedupe/getEntityDedupeTaskLogForCorp?${queryString}`);
  }

  getAssociatedMergesForMasterDupePair(dedupeTaskId: string, masterId: number, duplicateId: number): Observable<IMergeLog[]> {
    return this.http.get<IMergeLog[]>(`${environment.duplikitUrl}/MergeLog/getAssociatedMergesForMasterDupePair?dedupeTaskId=${ dedupeTaskId }&masterId=${ masterId }&duplicateId=${ duplicateId }`);
  }

  getMergeCountsForEachEntity(): Observable<IEntityMergeCounts> {
    return this.http.get<IEntityMergeCounts>(`${environment.duplikitUrl}/Dedupe/getMergeCountsForEachEntity`);
  }
}
